import { useEffect, useState } from "react";
import { Link } from "react-router";
import { getPushState, type PushState } from "../lib/push";

/** Nudges toward turning reminders on — the whole app depends on them. */
export function PushBanner() {
  const [state, setState] = useState<PushState | null>(null);
  useEffect(() => {
    getPushState().then(setState, () => setState(null));
  }, []);

  if (state === "needs-install") {
    return (
      <Link to="/ajustes" className="banner">
        📲 Instala la app en tu inicio para recibir recordatorios. Toca para ver cómo.
      </Link>
    );
  }
  if (state === "off") {
    return (
      <Link to="/ajustes" className="banner">
        🔔 Activa los recordatorios para que te avisemos a la hora de cada hábito.
      </Link>
    );
  }
  return null;
}
